import React, { useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import locales from '@/locales/index';
import zhCN from 'rsuite/lib/IntlProvider/locales/zh_CN';
import enUS from 'rsuite/lib/IntlProvider/locales/en_US';
import { IntlProvider as RSuiteIntlProvider } from 'rsuite';
import { CustomProvider } from 'rsuite5';
import RsZhCN from 'rsuite5/locales/zh_CN';
import { getCurrentLocale } from '@/utils/locale';
import * as Yup from 'yup';

/**
 * @see https://github.com/jquense/yup/blob/master/src/locale.ts
 */
Yup.setLocale({
  mixed: {
    required: '请输入${path}',
    notType({ path, type }: any) {
      if (type === 'number') {
        return `${path}必须为数字`;
      }
    },
  },
  string: {
    min: '长度至少${min}',
    max: '长度不超过${max}',
    email: '${path}必须为合法的邮箱格式',
    url: '${path}必须为合法的 URL 格式',
  },
  number: {
    integer: '${path}必须为整数',
    min: '${path}不可小于 ${min}',
    max: '${path}不可大于 ${max}',
    moreThan: '${path}必须大于 ${more}',
  },
  date: {},
  object: {},
  array: {
    min: '请选择至少${min}个${path}',
  },
  boolean: {},
  //
  // gt: {
  //   number: '${path}必须大于${other}',
  // },
});

const RSLocaleMap: {
  [locale: string]: object;
} = {
  'zh-CN': zhCN,
  'en-US': enUS,
};

/**
 * 提供国际化能力
 * - react-intl
 * - rsuite intl
 */
const IntlProvider: React.FC = ({ children }) => {
  const [currentLocale, setLocale] = useState(getCurrentLocale());
  return (
    <ReactIntlProvider locale={currentLocale} messages={locales[currentLocale]}>
      <RSuiteIntlProvider locale={RSLocaleMap[currentLocale]}>
        <CustomProvider locale={RsZhCN}>{children}</CustomProvider>
      </RSuiteIntlProvider>
    </ReactIntlProvider>
  );
};

export default IntlProvider;
